import API from '../../services/api';

// ── Meta ──
export const fetchSecurityMeta = async () => (await API.get('/security/meta')).data;

// ── Login policies ──
export const fetchPolicies = async (params = {}) => (await API.get('/security/policies', { params })).data;
export const fetchPolicy = async (id) => (await API.get(`/security/policies/${id}`)).data;
export const createPolicy = async (data) => (await API.post('/security/policies', data)).data;
export const updatePolicy = async (id, data) => (await API.put(`/security/policies/${id}`, data)).data;
export const disablePolicy = async (id) => (await API.patch(`/security/policies/${id}/disable`)).data;

// ── Assignment ──
export const assignPolicy = async (data) => (await API.post('/security/assign-policy', data)).data;

// ── IP whitelist ──
export const fetchPolicyIps = async (id) => (await API.get(`/security/policies/${id}/ips`)).data;
export const addPolicyIp = async (id, data) => (await API.post(`/security/policies/${id}/ips`, data)).data;
export const removePolicyIp = async (id, ipId) => (await API.delete(`/security/policies/${id}/ips/${ipId}`)).data;

// ── Devices ──
export const fetchDevices = async (params = {}) => (await API.get('/security/devices', { params })).data;
export const registerDevice = async (data) => (await API.post('/security/devices', data)).data;
export const revokeDevice = async (id) => (await API.patch(`/security/devices/${id}/revoke`)).data;

// ── Allowed devices (SPECIFIC_DEVICES) ──
export const fetchAllowedDevices = async (employeeId) =>
  (await API.get(`/security/employees/${employeeId}/allowed-devices`)).data;
export const addAllowedDevice = async (data) => (await API.post('/security/allowed-devices', data)).data;
export const removeAllowedDevice = async (data) =>
  (await API.delete('/security/allowed-devices', { data })).data;

// ── Audit ──
export const fetchAudit = async (params = {}) => (await API.get('/security/audit', { params })).data;
